import { Skeleton } from '@chakra-ui/react';
import React from 'react';
import { useParams } from 'react-router-dom';
import { z } from 'zod';

import { BenchmarkRateView } from './BenchmarkRateView';
import { FixedRateView } from './FixedRateView';
import { useCreditAgreementStore } from '~/core/routes/settings/implementations/common/CreditAgreementProvider/CreditAgreementProvider';

// Types
const RouteParamsStruct = z.object({
  pricingOptionId: z.string({ message: 'Missing URL parameter' }),
});

export const PricingOptionSummary = () => {
  const params = useParams();
  const { pricingOptionId } = RouteParamsStruct.parse(params);
  const pricingOption = useCreditAgreementStore((store) =>
    store.creditAgreement?.loanMechanicsV1?.pricingOptions?.find(
      (pricingOptionItem) => pricingOptionItem.key === pricingOptionId,
    ),
  );

  // TODO: throw an error if no pricing option is found. issue was loading credit agreement after navigation. - https://github.com/finleytechnologies/atlas/pull/16191/files#r2049249055
  if (pricingOption?.type === 'fixed')
    return (
      // using 'key' to setup / distinguish form states for each pricing option id
      <FixedRateView key={pricingOptionId} pricingOptionId={pricingOptionId} />
    );
  if (pricingOption?.type === 'benchmark')
    return (
      // using 'key' to setup / distinguish form states for each pricing option id
      <BenchmarkRateView
        key={pricingOptionId}
        pricingOptionId={pricingOptionId}
      />
    );
  return <Skeleton height="500px" />;
};
